<template lang="pug">
  #GroupPush
    appHeader(
      :hasBackTool="true"
      :targetRouterName="route"
      :title="'顧客篩選結果'"
    )
    router-view.content-body-hasFooter(style='padding-top: 72px;')
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import { SM_ITEMS_LIST_INDEX } from '@/router/sm/items-list';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'GroupPushComponent',
  components: {
    appHeader
  },
  data() {
    return {
      route: SM_ITEMS_LIST_INDEX
    };
  }
};
</script>
